import React from 'react';
import { get, post, put, del, patch } from '../../../../Utility/Http';
import {
    hotelRoomTypesSearchListGet,
    destinationListGet,
    filterPanelListGet,
    paymentPriceDistributionGet,
    paymentCreatePost,
    paymentCreatePatch,
    uploadScreenshotPost,
    creditPointGet,
    subscribApiCallFn,
    getPaymentDetailsGet,
    paymentDetailsDeleteApi,
    guestCreateApi,
    emailCheckApiGet,
    signupCustomerApi,
    packageTourListGet,
    uploadPersonDetailsFn,
    updatePersonDetailsApi,
    createDmcLeadApi,
    createDmcNoteApi,
    tourLocationListGet,
    hotelCountByCountryGet,
    hotelCountByTagGet,
    hotelCountByCityGet,
    hotelCountByStateGet,
    destinationCityCountGet,
    destinationStateCountGet,
    tagCountGet,
    destinationCountryCountGet,
    getTourTagCountGet,
    getTagWiseCountGet
} from '../Model/HomeModel';

export const hotelRoomTypesSearchList = async (data) => {
    const response = await get(`${process.env.EXTENDED_URL}customer/search`, data);
    return hotelRoomTypesSearchListGet(response);
};

export const destinationList = async (data) => {
    const response = await get(`${process.env.EXTENDED_URL}customer/location`, data);
    return destinationListGet(response);
};

export const filterPanelList = async (data) => {
    const response = await get(`${process.env.EXTENDED_URL}customer/filters`, data);
    return filterPanelListGet(response);
};
export const paymentPriceDistribution = async (data) => {
    const response = await post(`${process.env.EXTENDED_URL}customer/price_distribution`, data);
    return paymentPriceDistributionGet(response);
};


export const paymentCreate = (data, id, type) => {
    if (type == 'post') {
        return post(`${process.env.EXTENDED_URL}customer/payment`, data).then((response) => {
            return paymentCreatePost(response)
        });
    } else {
        return patch(`${process.env.EXTENDED_URL}customer/payment/${id}`, data).then((response) => {
            return paymentCreatePatch(response)
        });
    }
};
export const uploadScreenshot = (data) => {
    return post(`${process.env.EXTENDED_URL}customer/payment/upload_screensort`, data).then((response) => {
        return uploadScreenshotPost(response)
    });
};
export const getCreditPoint = (data) => {
    return get(`${process.env.EXTENDED_URL}customer/payment/get_credit_points`, data).then((response) => {
        return creditPointGet(response)
    });
};
export const subscribApiCall = async (data) => {
    const response = await post(`${process.env.EXTENDED_URL}subscription_details`, data);
    return subscribApiCallFn(response);
};
export const getPaymentDetails = (id, data) => {
    return get(`${process.env.EXTENDED_URL}customer/payment?booking_id=${id}`, data).then((response) => {
        return getPaymentDetailsGet(response)
    });
};
export const getCustomerPaymentDetails = (id, data) => {
    return get(`${process.env.EXTENDED_URL}customer/customer_payment?booking_id=${id}`, data).then((response) => {
        return getPaymentDetailsGet(response)
    });
};
export const paymentDetailsDelete = (data) => {
    return del(`${process.env.EXTENDED_URL}customer/payment`, data).then((response) => {
        return paymentDetailsDeleteApi(response)
    });
};

export const guestCreate = async (data, headers) => {
    const response = await post(`${process.env.EXTENDED_URL}customer/create`, data, headers);
    return guestCreateApi(response);
};
export const emailCheckApi = async (data) => {
    const response = await get(`${process.env.EXTENDED_URL}customer/check_email`, data);
    return emailCheckApiGet(response);
};
export const signupCustomer = async (data, veryfiFlag) => {
    if (!veryfiFlag) {
        const response = await post(`${process.env.EXTENDED_URL}users/signup_customer`, data);
        return signupCustomerApi(response);
    }
    if (veryfiFlag) {
        const response = await post(`${process.env.EXTENDED_URL}users/confirm_signup`, data);
        return signupCustomerApi(response);
    }


};

export const getGSTdetails = async () => {
    let response = await get(`${process.env.EXTENDED_URL}/sac_customer_code`);
    return packageTourListGet(response);
};

export const uploadPersonDetails = async (data) => {
    const response = await post(`${process.env.EXTENDED_URL}v4/customerDetails/add`, data);
    return uploadPersonDetailsFn(response);
};

export const updatePersonDetails = async (id, data) => {
    const response = await patch(`${process.env.EXTENDED_URL}v4/customerDetails/${id}`, data);
    return updatePersonDetailsApi(response);
};

export const createDmcLead = (data) => {
    return post(`${process.env.EXTENDED_URL}v4/dmc/leads/customer`, data).then((response) => {
        return createDmcLeadApi(response);
    });
};

export const createDmcNote = (data) => {
    return post(`${process.env.EXTENDED_URL}v4/notes/customer`, data).then((response) => {
        return createDmcNoteApi(response);
    });
};

export const getTourLocationList = async () => {
    const response = await get(`${process.env.EXTENDED_URL}customer/tour-location-list`);
    return tourLocationListGet(response);
};

export const hotelCountByCountry = async (data) => {
    const response = await get(`${process.env.EXTENDED_URL}customer/hotel-count-by-country`, data);
    return hotelCountByCountryGet(response);
};

export const hotelCountByTag = async (data) => {
    const response = await get(`${process.env.EXTENDED_URL}customer/hotel-count-by-tag`, data);
    return hotelCountByTagGet(response);
};

export const hotelCountByCity = async (data) => {
    const response = await get(`${process.env.EXTENDED_URL}customer/hotel-count-by-city`, data);
    return hotelCountByCityGet(response);
};

export const hotelCountByState = async (data) => {
    const response = await get(`${process.env.EXTENDED_URL}customer/hotel-count-by-state`, data);
    return hotelCountByStateGet(response);
};

export const destinationCityCount = async (data) => {
    const response = await get(`${process.env.EXTENDED_URL}tours/customer/destination-city-count`, data);
    return destinationCityCountGet(response);
};

export const destinationStateCount = async (data) => {
    const response = await get(`${process.env.EXTENDED_URL}tours/customer/destination-state-count`, data);
    return destinationStateCountGet(response);
};

export const tagCount = async (data) => {
    const response = await get(`${process.env.EXTENDED_URL}tours/customer/tag-count`, data);
    return tagCountGet(response);
};

export const destinationCountryCount = async (data) => {
    const response = await get(`${process.env.EXTENDED_URL}tours/customer/destination-country-count`, data);
    return destinationCountryCountGet(response);
};

export const getTourTagCount = async (data) => {
    const response = await post(`${process.env.EXTENDED_URL}tours/customer/tour-tag-count`, data);
    return getTourTagCountGet(response);
};
export const getTagWiseCount = async (data) => {
    const response = await get(`${process.env.EXTENDED_URL}tours/customer/tag-wise-count`, data);
    return getTagWiseCountGet(response);
};
export const getHotelTagWiseCount = async (data) => {
    const response = await get(`${process.env.EXTENDED_URL}customer/hotel-tag-wise-count`, data);
    return getTagWiseCountGet(response);
};